import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { savemembershiptypes, editmembershiptypes } from "../store/slices/userSlice"; // Adjust these as needed

Modal.setAppElement("#root");

function Membershiptypemodel({ isModalOpen, setIsModalOpen, reloadData, selected }) {
    const [formData, setFormData] = useState({
        id: 0,
        name: "",
        duration: 0,
        amount: 0,
        description: "",
        paypal_plan_id:"",
        status: 1
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selected) {
            setFormData({
                id: selected.id || 0,
                name: selected.name || "",
                duration: selected.duration || 0,
                amount: selected.amount || 0,
                description: selected.description || "",
                paypal_plan_id: selected.paypal_plan_id || "",
                status: selected.status ?? 1,  // default to 1 if null/undefined
            });
        } else {
            setFormData({
                id: 0,
                name: "",
                duration: 0,
                amount: 0,
                description: "",
                paypal_plan_id: "",
                status: 1,
            });
        }
    }, [selected]);
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: ["duration", "amount", "status"].includes(name) ? Number(value) : value,
        }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, duration, amount, description } = formData;
    
        if (!name.trim() || !duration || !amount || !description.trim()) {
            Swal.fire("Validation Error", "All fields are mandatory.", "warning");
            return;
        }
    
        setLoading(true);
    
        try {
            const response = formData.id === 0
                ? await savemembershiptypes(formData)
                : await editmembershiptypes(formData);
    
            if (response?.status === 200) {
                Swal.fire("Success", `Membership type ${formData.id === 0 ? "saved" : "updated"} successfully!`, "success");
                reloadData();
                setIsModalOpen(false);
            } else {
                Swal.fire("Error", response?.message || "Operation failed!", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong!", "error");
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            style={{
                overlay: { background: "rgba(0, 0, 0, 0.5)" },
                content: {
                    width: "400px",
                    margin: "auto",
                    padding: "20px",
                    borderRadius: "10px",
                },
            }}
        >
            <div className="modal-header bg-primary text-white d-flex justify-content-between align-items-center p-3">
                <h5 className="mb-0">{formData.id ? "Edit Membership Type" : "Add Membership Type"}</h5>
                <button className="btn-close" onClick={() => setIsModalOpen(false)}></button>
            </div>

            <div className="modal-body">
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Duration (in days)</Form.Label>
                        <Form.Control
                            type="number"
                            name="duration"
                            value={formData.duration}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Amount ($)</Form.Label>
                        <Form.Control
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Paypal Plan</Form.Label>
                        <Form.Control
                            type="text"
                            name="paypal_plan_id"
                            value={formData.paypal_plan_id}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {formData.id != "0" && (
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                required
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </Form.Select>
                        </Form.Group>)}


                    <div className="text-center">
                        <Button type="submit" variant="primary" disabled={loading}>
                            {loading ? "Saving..." : formData.id ? "Update" : "Submit"}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default Membershiptypemodel;
